@if (deviceService.isMobile && userService.isAuthenticated) {
    @if (!isDataLoaded) {
        <div class="user-banner-loader">
            <div class="details">
                <div class="background-color label"></div>
                <div class="background-color id"></div>
            </div>
            <div class="background-color button"></div>
        </div>
    } @else {
        <div class="user-banner" data-testid="userBanner">
            <div class="banner-content" data-testid="bannerContent">
                <div class="user-details">
                    <div class="user-name" data-testid="userName">
                        <span>{{ content?.HiText }}</span>
                        <span>{{ firstName | titlecase }}</span>
                        @if (isVipUser) {
                            <span class="vip-badge"> <img alt="" [src]="content.VipBadge" /></span>
                        }
                    </div>
                    @if (isMlifeProfileAvailable && mlifeProfile?.mLifeNo) {
                        <div class="rewards-details" data-testid="rewardsDetails">
                            <span data-testid="rewardsLabel">{{ content?.MGMRewardstext }}</span>
                            <span data-testid="rewardsId">{{ mlifeProfile?.mLifeNo }}</span>
                        </div>
                    }
                </div>
                @if (isMlifeProfileAvailable && content?.ViewCardButton) {
                    <button
                        ds-button
                        variant="outline"
                        kind="secondary"
                        size="small"
                        data-testid="viewCardButton"
                        (click)="viewCardClick()"
                        inverse="true">
                        {{ content?.ViewCardButton }}
                    </button>
                }
            </div>
        </div>
    }
}
